import { Button } from "@mui/material";
import { signOut } from "firebase/auth";
import React from "react";
import { auth } from "../firebaseConfig";

const LogoutButton = () => {
  const handleLogout = async () => {
    await signOut(auth);
    window.location.href = "/sign-in";
  };
  return (
    <div>
      <Button
        variant="contained"
        color="primary"
        onClick={handleLogout}
        sx={{ position: "absolute", top: 16, right: 16, zIndex: 1000 }}
      >
        Çıkış Yap
      </Button>
    </div>
  );
};

export default LogoutButton;
